export const IdProdutoImgMap: {
  id: number,
  img: string,
  url?: string
}[] = [
  {
    id: 1,
    img: '/logo_id_veles.png'
  },
  {
    id: 3,
    img: '/logo_ia_veles.png'
  },
  {
    id: 5,
    img: '/logo_dash_veles.png',
    url: '/dashboard'
  },
  {
    id: 6,
    img: '/logo_geo_veles.png'
  },
  {
    id: 9,
    img: '/logo_auto_veles.png'
  }
]
